import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import Pending from "../components/vouchers/pending";

const PendingVouchersView = () => (
  <Container fluid className="main-content-container pb-1">
    <Row>
      <Col md="12">
        <Pending />
      </Col>
    </Row>
  </Container>
);

export default PendingVouchersView;
